type TLicense = {
  asOneBackupRecordingAllowed: boolean;
};

export const getGlobalBackupRecordingValue = (licenses: TLicense[]) => {
  if (licenses.every((license) => license.asOneBackupRecordingAllowed !== false)) {
    return 'On';
  }
  if (licenses.every((license) => license.asOneBackupRecordingAllowed !== true)) {
    return 'Off';
  }
  return 'Mixed';
};
